import {Link} from 'shared/pretty-easy-navigation/models';
import {NavigationContext} from '../navigation.context';

export const NotepadListLink = (_context: NavigationContext): Link => ({
    type: 'link',
    label: 'navigation.notepad',
    link: '/notepad/list',
    icon: 'navigation-link__notepad-list',
});